import { render, staticRenderFns } from "./ProductThumbnail.vue?vue&type=template&id=13165923&scoped=true&"
import script from "./ProductThumbnail.vue?vue&type=script&lang=ts&"
export * from "./ProductThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./ProductThumbnail.vue?vue&type=style&index=0&id=13165923&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13165923",
  null
  
)

export default component.exports